export const range = (start, end) => {
	if (start === end) return [start]
	if ([1, 2, 3].includes(end)) return [1, 2, 3, 4, 5]
	return [start, ...range(start + 1, end)]
}